import React, { ReactNode } from "react";
import { Dropdown } from "react-bootstrap";
import { useSettings } from "../../settings/SettingsProvider";

interface SettingsDropdownItemProps
    extends Omit<React.ComponentProps<typeof Dropdown.Item>, "onClick"> {
    path: string;
    children: ReactNode;
}

export const SettingsDropdownItem: React.FC<SettingsDropdownItemProps> = ({
    path,
    children,
    ...props
}) => {
    const { validPaths, open } = useSettings();
    if (!validPaths.includes(path)) {
        return null;
    }
    return (
        <Dropdown.Item {...props} onClick={() => open([path])}>
            {children}
        </Dropdown.Item>
    );
};
